import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

function NavBar() {
  const [active, setActive] = React.useState()
  useEffect(() => {
    setActive(window.location.pathname)
  }, [window.location.pathname])

  return (
    <header id="masthead"  className="header ttm-header-style-03">
      <div className="top_bar ttm-bgcolor-darkgrey clearfix">
        <div className="mx-2">
          <div className="row no-gutters">
            <div className="col-xl-12 d-flex flex-row align-items-center">
              <div className="top_bar_contact_item">
                <div className="top_bar_icon"><i className="ti ti-email" /></div><a href="mailto:sales@naskinternational.com">sales@naskinternational.com</a>
              </div>
              <div className="top_bar_contact_item">
                <div className="top_bar_icon"><i className="ti ti-location-pin" /></div>Office # 2, 3rd Floor, 21-CCA, DHA 8 (Ex-Park View), Block D Cantt, Lahore, Pakistan
              </div>
              <div className="top_bar_contact_item top_bar_social ms-auto p-0">
                <div className="social-icons text-lg-right">
                  <ul className="social-icons list-inline">
                    <li className="tm-social-facebook"><a target="_blank" href="https://www.facebook.com/naskinternational/"><i className="fa fa-facebook" /></a></li>
                    <li className="tm-social-twitter"><a target="_blank" href="https://twitter.com/NaskInternatio1"><i className="fa fa-twitter" /></a></li>
                    <li className="tm-social-flickr"><a target="_blank" href="	https://www.instagram.com/naskinternational/"><i className="fa-brands fa-instagram" /></a></li>
                    <li className="tm-social-linkedin"><a target="_blank" href="https://www.tiktok.com/@naskinternational"><i className="fa-brands fa-tiktok" /></a></li>
                    <li className="tm-social-linkedin"><a target="_blank" href="	https://www.youtube.com/channel/UCcUtzsrX2K8mGfiNXW7Kq-g"><i className="fa-brands fa-youtube" /></a></li>
                    <li className="tm-social-linkedin"><a target="_blank" href="https://www.pinterest.com/naskinternational/"><i className="fa-brands fa-pinterest-p" /></a></li>
                    <li className="tm-social-linkedin"><a target="_blank" href="https://www.linkedin.com/company/nask-international/"><i className="fa fa-linkedin" /></a></li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="site-header-menu" className="site-header-menu ttm-bgcolor-white">
        <div className="site-header-menu-inner ttm-stickable-header">
          <div className="mx-2">
            <div className="row">
              <div className="col-lg-12">
                <div className="site-navigation d-flex flex-row align-items-center justify-content-between">
                  <div className="site-branding ">
                    <Link className="home-link" to="/" title="Nask International" rel="home">
                      <img id="logo-img" height={37} width={138} className="img-fluid auto_size" src="images/logo.svg" alt="logo-img" />
                    </Link>
                  </div>
                  <div className="d-flex flex-row">
                    <div className="btn-show-menu-mobile menubar menubar--squeeze">
                      <span className="menubar-box">
                        <span className="menubar-inner" />
                      </span>
                    </div>
                    <nav className="main-menu menu-mobile" id="menu">
                      <ul className="menu">
                        <li className={`mega-menu-item ${active === "/" ? "active" : ""}`}>
                          <Link to="/" className="mega-menu-link">Home</Link>
                        </li>
                        <li className={`mega-menu-item ${active === "/about-us" ? "active" : ""}`}>
                          <Link to="/about-us">About Us</Link>
                        </li>
                        <li className={`mega-menu-item ${["/kitchen-textile", "/hospital-textile", "/promotional-textile"].includes(active) ? "active" : ""}`}>
                          <a style={{ cursor: "pointer" }} className="mega-menu-link">
                            Textile <i className="fa-solid fa-angle-down" />
                          </a>
                          <ul className="mega-submenu">
                            <li><Link to="/kitchen-textile">Kitchen Textile</Link></li>
                            <li><Link to="/hospital-textile">Hospital Textile</Link></li>
                            <li><Link to="/promotional-textile">Promotional Textile</Link></li>
                          </ul>
                        </li>

                        <li className={`mega-menu-item ${active === "/garments" ? "active" : ""}`}>
                          <Link to="/garments">Garments</Link>
                        </li>
                        <li className={`mega-menu-item ${[
                          "/cotton-tote-bags",
                          "/drawstring-bags",
                          "/promotional-bags",
                          "/personalized-bags",
                          "/laundry-bags",
                          "/cotton-sacks",
                          "/cotton-pouches",
                          "/non-woven-bags"
                        ].includes(active) ? "active" : ""}`}>
                          <Link className="mega-menu-link">Cotton Bags <i className="fa-solid fa-angle-down" /></Link>
                          <ul className="mega-submenu">
                            <li><Link to="/cotton-tote-bags">Cotton Tote Bags</Link></li>
                            <li><Link to="/drawstring-bags">Drawstring Bags</Link></li>
                            <li><Link to="/promotional-bags">Promotional Bags</Link></li>
                            <li><Link to="/personalized-bags">Personalized Bags</Link></li>
                            <li><Link to="/laundry-bags">Laundry Bags</Link></li>
                            <li><Link to="/cotton-sacks">Cotton Sacks</Link></li>
                            <li><Link to="/cotton-pouches">Cotton Pouches</Link></li>
                            <li><Link to="/non-woven-bags">Non Woven Bags</Link></li>
                          </ul>
                        </li>

                        <li className={`mega-menu-item ${[
                          "/bath-towels",
                          "/hotel-towels",
                          "/jacquard-towels",
                          "/kids-towels",
                          "/luxury-towels",
                          "/bathrobes",
                          "/promotional-towels",
                          "/beach-towels"
                        ].includes(active) ? "active" : ""}`}>
                          <Link className="mega-menu-link">Towels <i className="fa-solid fa-angle-down" /></Link>
                          <ul className="mega-submenu">
                            <li><Link to="/bath-towels">Bath Towels</Link></li>
                            <li><Link to="/hotel-towels">Hotel Towels</Link></li>
                            <li><Link to="/jacquard-towels">Jacquard Towels</Link></li>
                            <li><Link to="/kids-towels">Kids Towels</Link></li>
                            <li><Link to="/luxury-towels">Luxury Towels</Link></li>
                            <li><Link to="/bathrobes">Bathrobes</Link></li>
                            <li><Link to="/promotional-towels">Promotional Towels</Link></li>
                            <li><Link to="/beach-towels">Beach Towels</Link></li>
                          </ul>
                        </li>

                        <li className={`mega-menu-item ${["/work-gloves","/uniforms"].includes(active) ? "active" : ""}`}>
                          <Link className="mega-menu-link">Work Wear <i className="fa-solid fa-angle-down" /></Link>
                          <ul className="mega-submenu">
                            <li><Link to="/work-gloves">Work Gloves</Link></li>
                            <li><Link to="/uniforms">Uniforms</Link></li>

                          </ul>
                        </li>
                        <li className={`mega-menu-item ${["/inspection-services","/audit-services"].includes(active) ? "active" : ""}`}>
                          <Link className="mega-menu-link">QC Services <i className="fa-solid fa-angle-down" /></Link>
                          <ul className="mega-submenu">
                            <li><Link to="/inspection-services">Inspection Services</Link>
                            </li>
                            <li><Link to="/audit-services">Audit Services</Link></li>
                          </ul>
                        </li>
                        <li className={`mega-menu-item ${active === "/blog" ? "active" : ""}`}>
                          <Link to="/blog">Blog</Link>
                        </li>
                        <li className={`mega-menu-item ${active === "/contact-us" ? "active" : ""}`}>
                          <Link className="mega-menu-link">Contact us <i className="fa-solid fa-angle-down" /></Link>
                          <ul className="mega-submenu">
                            <li><Link to="/contact-us">Ask For Product Quotation</Link></li>
                            <li><Link to="/contact-us">Ask For Inspection Quotation</Link>
                            </li>
                          </ul>
                        </li>
                      </ul>
                    </nav>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}

export default NavBar